<script lang="ts">
    import { goto } from "$app/navigation";
    import { onMount } from "svelte";
    import { focusForm } from "$lib/stores/store";
    export let title;
    export let annualPrice;
    export let monthlyPrice;
    export let inspectionPrice;
    export let buttonColor = "variant-filled";
    import Terms from "../terms/Terms.svelte";
    // import { on } from "events";
    let showModal = false;
    function onKeyDown(e: { key: string }) {
        if (!showModal) {
            return;
        } else {
            if (e.key === "Escape" && showModal) {
                showModal = false;
                return;
            }
        }
    }
    function toggleModal() {
        showModal = showModal ? false : true;
    }

    function handleClick() {
        // if form is on page scroll to it, otherwise go to order page
        const formField = document.querySelector(".form-container");

        if (formField) {
            formField.scrollIntoView({ behavior: "smooth", block: "center" });
            $focusForm = true;
            console.log("focusForm: ", $focusForm);
            // formField.focus();
        } else {
            goto("/order");
        }
    }
</script>

{#if showModal}
    <div class="modal h-screen w-full">
        <div class="modal-content">
            <div class="flex flex-col max-h-screen max-w-fit">
                <div class="card overflow-y-scroll w-full max-h-screen max-w-fit m-4">
                    <Terms />
                </div>
            </div>
            <div class=" bg-primary-500 text-white w-full">
                <button on:click={toggleModal} class="close-button absolute w-full h-14 bottom-0 right-0 bg-tertiary-500">
                    <span class="close-button" style="color:white; font-size: 24px ">×</span>
                </button>
            </div>
        </div>
    </div>
{/if}

<div class="card-container p-0 flex flex-col gap-4">
    <div class="card">
        <div class=" w-full">
            <div class="mb-2">
                <span class="text-2xl font-bold w-full mb-4">{title} Inspection Guarantee</span>
            </div>

            <slot />

            <div class="flex flex-col justify-center mx-auto w-full mt-6 bg-surface-500 p-4 rounded-xl">
                <p class=" flex w-full justify-center gap-1">
                    <span class=" tracking-wider text-xl">
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(monthlyPrice)}
                    </span>
                    <span class="text-tertiary-500 text-xs">/month </span>
                </p>
                <p class=" flex w-full justify-center gap-1 text-surface-700">- or -</p>

                <p class=" flex w-full justify-center gap-1">
                    <span class=" tracking-wider text-xl">
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(annualPrice)}
                    </span>
                    <span class="text-tertiary-500 text-xs">/year </span>
                </p>
            </div>
        </div>
        <!-- <hr /> -->
        <div class="flex flex-col justify-center mx-auto w-full mt-4">
            <ul>
                <li><i class="fa fa-check"></i>Cooling System</li>
                <li><i class="fa fa-check"></i>Suspension & Steering</li>
                <li><i class="fa fa-check"></i>Electrical System</li>
                <li><i class="fa fa-check"></i>Engine</li>
                <li><i class="fa fa-check"></i>Transmission</li>
                <li><i class="fa fa-check"></i>Exhaust</li>
                <li><i class="fa fa-check"></i>HVAC</li>
            </ul>
        </div>
        <div class="card-footer mt-4">
            <button type="button" on:click={toggleModal} class="w-full btn text-lg button-variant-filled bg-primary-500 text-white">See Full Details</button>
        </div>
    </div>
</div>

<svelte:window on:keydown={onKeyDown} />

<style>
    .modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }
    .card-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        margin: 1rem;
    }
    .card {
        padding: 1rem;
    }
    .card-header p {
        font-size: 16px;
        font-weight: 400;
    }
    .card-header > p > span {
        @apply text-tertiary-500;
    }
    hr {
        width: 90%;
        margin: 1rem;
        height: 1px;
        background-color: black;

        display: flex;
        border: none;
        justify-content: center;
        align-items: center;
    }
    ul {
        @apply w-full;

        margin-top: 5rem;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        justify-content: center;
        /* space even */
        align-items: flex-start;
        gap: 10px;
        list-style: none;
        padding: 1rem 1rem 1rem 0;
        margin: 0;
    }
    ul li {
        display: flex;
        align-items: center;
        text-align: left;
        /* margin-bottom: 5px; */
        line-height: 1rem;
        padding: 0 1rem;

        color: #000;

        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }
    ul li i {
        margin-right: 10px;
        border: solid black 2px;
        color: var(--c2-red);
        /* background-color: black; */
        border-radius: 5rem;
        padding: 3px;
    }
    .card-header {
        display: flex;
        flex-direction: column;
        margin: 0rem 1rem 1rem 0;
        justify-content: space-between;
        gap: 10px;
    }
    .card {
        border-radius: 20px;
        min-width: 400px;
    }
    .price {
        color: #000;

        font-family: Inter;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }

    h3 {
        color: #000;

        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
    }
    /* button {
        width: 100%;
        font-size: 20px;
        font-weight: 700;
        color: white;
    } */
</style>
